<template>
  <pnet-validation-observer>
    <div class="row">
      <div class="col-md-10">
        <label>
          <small>{{label}}</small>
        </label>
        <div class="form-group">
          <div class="col">
            <label>
              <small>Mensile</small>
            </label>
            <div class="form-row">
              <div class="col-6">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.mensile"
                  :rules="{required:true}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'mensile'"
                  :disabled="isNDMensile"
                ></pnet-input>
              </div>
              <div class="col-1">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.mensileSign"
                  :rules="{required:false}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'mensileSign'"
                  v-if="!isNDMensile"
                ></pnet-input>
              </div>
            </div>
          </div>
          <div class="col">
            <label>
              <small>Bimestrale</small>
            </label>
            <div class="form-row">
              <div class="col-6">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.bimestrale"
                  :rules="{required:true}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'bimestrale'"
                  :disabled="isNDBimestrale"
                ></pnet-input>
              </div>
              <div class="col-1">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.bimestraleSign"
                  :rules="{required:false}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'bimestraleSign'"
                  v-if="!isNDBimestrale"
                ></pnet-input>
              </div>
            </div>
          </div>
          <div class="col">
            <label>
              <small>Trimestrale</small>
            </label>
            <div class="form-row">
              <div class="col-6">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.trimestrale"
                  :rules="{required:true}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'trimestrale'"
                  :disabled="isNDTrimestrale"
                ></pnet-input>
              </div>
              <div class="col-1">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.trimestraleSign"
                  :rules="{required:false}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'trimestraleSign'"
                  v-if="!isNDTrimestrale"
                ></pnet-input>
              </div>
            </div>
          </div>
          <div class="col">
            <label>
              <small>Quadrimestrale</small>
            </label>
            <div class="form-row">
              <div class="col-6">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.quadrimestrale"
                  :rules="{required:true}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'quadrimestrale'"
                  :disabled="isNDQuadrimestrale"
                ></pnet-input>
              </div>
              <div class="col-1">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.quadrimestraleSign"
                  :rules="{required:false}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'quadrimestraleSign'"
                  v-if="!isNDQuadrimestrale"
                ></pnet-input>
              </div>
            </div>
          </div>
          <div class="col">
            <label>
              <small>Semestrale</small>
            </label>
            <div class="form-row">
              <div class="col-6">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.semestrale"
                  :rules="{required:true}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'semestrale'"
                  :disabled="isNDSemestrale"
                ></pnet-input>
              </div>
              <div class="col-1">
                <pnet-input
                  input-class="form-control text-left"
                  layout="horizontal"
                  v-model="frazionamento.semestraleSign"
                  :rules="{required:false}"
                  :customMessages="{required:'Il campo deve essere valorizzato.'}"
                  :name="'semestraleSign'"
                  v-if="!isNDSemestrale"
                ></pnet-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import { PnetInput } from "@previnet/vue-input";
export default Vue.extend({
  props: ["label", "value", "isNDMensile", "isNDBimestrale", "isNDTrimestrale", "isNDQuadrimestrale", "isNDSemestrale"],
  components:{
    PnetInput,
  },
  data: function() {
    return {
      frazionamento: {}
    }
  },
  mounted() {
    this.frazionamento = this.value;
  },
  updated() {
    if (this.$props.isNDMensile) {
      this.frazionamento.mensile = "n.d.";
      this.frazionamento.mensileSign = "";
    } else if (this.frazionamento.mensile == "n.d.") {
      this.frazionamento.mensile = "";
      this.frazionamento.mensileSign = "%";
    }
    if (this.$props.isNDBimestrale) {
      this.frazionamento.bimestrale = "n.d.";
      this.frazionamento.bimestraleSign = "";
    } else if (this.frazionamento.bimestrale == "n.d.") {
      this.frazionamento.bimestrale = "";
      this.frazionamento.bimestraleSign = "%";
    }
    if (this.$props.isNDTrimestrale) {
      this.frazionamento.trimestrale = "n.d.";
      this.frazionamento.trimestraleSign = "";
    } else if (this.frazionamento.trimestrale == "n.d.") {
      this.frazionamento.trimestrale = "";
      this.frazionamento.trimestraleSign = "%";
    }
    if (this.$props.isNDQuadrimestrale) {
      this.frazionamento.quadrimestrale = "n.d.";
      this.frazionamento.quadrimestraleSign = "";
    } else if (this.frazionamento.quadrimestrale == "n.d.") {
      this.frazionamento.quadrimestrale = "";
      this.frazionamento.quadrimestraleSign = "%";
    }
    if (this.$props.isNDSemestrale) {
      this.frazionamento.semestrale = "n.d.";
      this.frazionamento.semestraleSign = "";
    } else if (this.frazionamento.semestrale == "n.d.") {
      this.frazionamento.semestrale = "";
      this.frazionamento.semestraleSign = "%";
    }
  },
  methods: {},
  watch: {
    frazionamento: {
      deep:true,
      handler(){
        this.$emit('input', this.frazionamento);
      }
    },
    value: {
      handler(){
        this.frazionamento = this.value;
      }
    },
  },
});
</script>
